export enum SidebarViewModes {
  default = 'default',
  extended = 'extended',
  hidden = 'hidden',
  dashboard = 'dashboard',
}
